import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import no from './locales/no.json'

const savedLocale = localStorage.getItem('locale') || 'en'

export default createI18n({
  legacy: false,
  locale: savedLocale,
  fallbackLocale: 'en',
  messages: { en, no },
  warnHtmlMessage: false,
})
